module.exports = __webpack_public_path__ + "static/media/009_iOS - 11 - MESSAGE CENTER loading.ca45e82c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/009_iOS - 11 - MESSAGE CENTER loading.png
// module id = 506
// module chunks = 0